export default function DashToggleButton({ activeView, onChange, options = [] }) {
    return (
        <div
            className="
                dash-toggle-button
                relative inline-flex h-[50px] w-[255px] shrink-0 items-center
                self-start justify-self-start gap-1 rounded-[25px] -translate-y-[4px]
                bg-[radial-gradient(circle_at_20%_0%,#333841_0%,#16181C_28%,#0B0C0E_66%)]
                p-[5px]
            "
        >
            {options.map((option) => {
                const isActive = activeView === option.value;

                return (
                    <button
                        key={option.value}
                        type="button"
                        aria-pressed={isActive}
                        onClick={() => onChange(option.value)}
                        className={`relative z-10 flex h-[40px] flex-1 cursor-pointer items-center justify-center
                        whitespace-nowrap rounded-[28px] px-3 text-[18px] font-semibold leading-[23px]
                        ${isActive
                            ? "dash-toggle-button bg-[linear-gradient(145deg,#12C7DF_0%,#2C4999_48%,#222C44_100%)] text-[#F4FFFF]"
                            : "border-transparent bg-transparent text-[#676C74] hover:text-[#8B919B]"
                        }
`}
                    >
                        {option.label}
                    </button>
                );
            })}
        </div>
    );
}
